export enum Achievements {
    HUNTER = 'hunter',
    CUTE = 'cute',
    CHAMPION = 'champion',
    DUMPLING = 'dumpling',
    QUIZ = 'quiz',
    NEW_YEAR_STORY = 'new_year_story',
    WALK_MOUSE_GOAL = 'walk_mouse_goal',
    NY_2024 = 'ny_2024',
    NY_2025 = 'ny_2025',
    MOUSE_FRIEND = 'mouse_friend_goal',
    FLOWER = 'flower',
    ADMIN = 'admin'
}

export const achievementsList = [
    Achievements.HUNTER,
    Achievements.CUTE,
    Achievements.CHAMPION,
    Achievements.DUMPLING,
    Achievements.QUIZ,
    Achievements.NEW_YEAR_STORY,
    Achievements.WALK_MOUSE_GOAL,
    Achievements.NY_2024,
    Achievements.NY_2025,
    Achievements.MOUSE_FRIEND,
    Achievements.FLOWER,
    Achievements.ADMIN
];